export const formPlaceholderTradPrefix = 'form_placeholders';
export const formValidationTradPrefix = 'form_validation';
export const successMessageTradPrefix = 'success';
export const errorMessageTradPrefix = 'errors' as const;
export const dateFilterTradPrefix = 'date_dropdown';
export const formLabelsTradPrefix = 'form_labels';
export const languageTradPrefix = 'language';
export const roleTradPrefix = 'roles';
export const transactionStatusTradPrefix = 'transaction_status';
export const notificationsTradPrefix = 'notifications';
export const commonTradPrefix = 'common';
export const ticketStatusTradPrefix = 'ticket_status';
export const ariaLabelsTradPrefix = 'aria_labels';
export const ticketTypeTradPrefix = 'ticket_type';
export const paymentMethodsTradPrefix = 'payment_methods';
export const transactionTypesTradPrefix = 'transaction_types';
export const refundTypeTradPrefix = 'refund_type';
export const featureInterestBannerTradPrefix = 'common.feature_interest_banner';
export const alertsInterestBannerTradPrefix = 'alerts_page.interest_banner';
export const reconciliationsInterestBannerTradPrefix = 'conciliations.interest_banner';
